// External libraries
import React from 'react';
import { func } from 'prop-types';
import { useStoreState } from 'easy-peasy';
import { FloatingLabelInput } from '@checkout/react-components';

// Internal modules
import { getContent } from '@/lib';
import { useMountLogging } from '@/lib/reactHooks';
import { blurHandler, changeHandler, focusHandler } from './handlers';
import { validationFunctionMap } from './validation';

const IdentityDocumentNumber = props => {
  useMountLogging('IdentityDocumentNumber');
  const identityDocumentNumber = useStoreState(
    ({ form }) => form.identityDocumentNumber,
  );
  const { value: identityDocumentType } = useStoreState(
    ({ form }) => form.identityDocumentType,
  );

  return (
    <FloatingLabelInput
      blurHandler={blurHandler}
      changeHandler={changeHandler}
      focusHandler={focusHandler}
      id="identityDocumentNumber"
      label={getContent('fieldLabels.identityDocumentNumber')}
      required={true}
      // validationFn defaults to generic validation if null
      validationFn={validationFunctionMap[identityDocumentType]}
      {...identityDocumentNumber}
    />
  );
};

IdentityDocumentNumber.propTypes = {
  blurHandler: func,
  changeHandler: func.isRequired,
  focusHandler: func,
};

export { IdentityDocumentNumber };
